import { render, staticRenderFns } from "./installerPreview.vue?vue&type=template&id=64d0aab4&scoped=true&lang=pug"
import script from "./installerPreview.vue?vue&type=script&lang=js"
export * from "./installerPreview.vue?vue&type=script&lang=js"
import style0 from "./installerPreview.vue?vue&type=style&index=0&id=64d0aab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0aab4",
  null
  
)

export default component.exports